<template>
	<div v-click-outside="clickOutside">
		<div class="dropdown" @click="showDropdown">
			<div class="overselect"></div>
			<select class="c-form-input" v-if="type=='circuit'">
				<option value="">Select Devices</option>
			</select>
			<select class="c-form-input" v-else-if="type=='site'">
				<option value="">Select Sites to be linked</option>
			</select>
			<select class="c-form-input" v-else>
				<option value="">Select Circuits to be linked</option>
			</select>
		</div>
		<div class="multiselect" v-if="show">
			<ul v-if="type == 'circuit'" class="circuit-select">
				<li v-if="allclicked">
					<span class="selectall-text" @click="selectall()">
						Select All</span>
				</li>
				<li v-else><span class="selectall-text" @click="disselectall()">Disselect All</span> </li>
				<li v-for="(option, index) in options" :key="index">
					<input class="checkbox-effect checkbox-effect-4"
								 type="checkbox"
								 :id="index"
								 :value="option.field"
								 v-model="selected">
					<label :for="index" class="field-name">{{ option.label }}</label>
				</li>
			</ul>
			<ul v-else-if="type=='site-circuits'" class="site-select">
				<li v-for="(option, index) in options" :key="index">
					<input class="checkbox-effect checkbox-effect-4"
								 type="checkbox"
								 :id="index"
								 :value="option.order"
								 v-model="selected">
					<label :for="index" class="field-name">{{ option.name }}</label>
				</li>
			</ul>
			<ul v-else class="site-select">
				<li v-for="(option, index) in options" :key="index">
					<input class="checkbox-effect checkbox-effect-4"
								 type="checkbox"
								 :id="index"
								 :value="option.id"
								 v-model="selected">
					<label :for="index" class="field-name">{{ option.name }}</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import vClickOutside from 'vue-click-outside';
export default {
	name: 'MultiSelect',
	props: ['options', 'type'],
	data() {
		return {
			show: false,
			fullData: [],
			nonPowerData: [],
			selected:[],
			allclicked: false,
		}
	},
	directives: {
		'click-outside': vClickOutside,
	},
	created() {
		if (this.options.length > 0) {
			this.options.map(option => {
				if (option.type !== 'Voltage' && option.type !== 'Frequency') {
					this.fullData.push(option.field)
				} else {
					this.nonPowerData.push(option.field);
				}
			})
		}
		this.selected = this.fullData;
	},
	methods: {
		showDropdown() {
			this.show = !this.show
		},
		clickOutside() {
			if (this.show) {
				this.show = false;
			}
		},
		selectall() {
			this.allclicked = !this.allclicked;
			this.selected = [...this.nonPowerData, ...this.fullData];
		},
		disselectall() {
			this.selected = [];
			this.allclicked = !this.allclicked;
		}
	},
	watch: {
		selected(val) {
			if(val.length == 32) this.allclicked = !this.allclicked;
			this.$emit('checked', val)
		},
	}
}
</script>

<style lang="scss" scoped>
$border-color: #bcb9b9;
$icon-color-4: #72195A;
@mixin transition-mix($property: all, $duration: 0.2s, $timing: linear, $delay: 0s) {
	transition-property: $property;
	transition-duration: $duration;
	transition-timing-function: $timing;
	transition-delay: $delay;
}

@mixin position-absolute ($top: null, $left: null, $right: null, $bottom: null) {
	position: absolute;
	top: $top;
	left: $left;
	right: $right;
	bottom: $bottom;
}
.dropdown {
	position: relative;
	cursor: pointer;
}
.selectall-text {
	font-size: 16px;
	color: #1ed365;
	cursor: pointer;
}
.c-form-input {
	width: 200px;
	height: 30px;
	border: 1px	solid #FDFDFD;
	background-color: #1E365D;
	color: white;
	border-radius: 4px;
}

.multiselect {
	position: relative;

	ul {
		border: 1px solid #FDFDFD;
		border-top: 0;
		border-radius: 0 0 3px 3px;
		left: 0px;
		padding: 8px 8px;
		position: absolute;
		width: 200px;
		list-style: none;
		max-height: 150px;
		overflow: auto;
		z-index: 10;
		background-color: #1e365d;
		color: white;
	}
}

.overselect {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}
.checkbox-effect:not(:checked),
.checkbox-effect:checked{
	position: absolute;
	left: -9999px;
}

label.field-name {
	cursor: pointer;
	position: relative;
	display: flex;
	align-items: center;
	color: #FFFFFF;
	font-size: 14px;
}

.checkbox-effect-4:not(:checked) + label:before,
.checkbox-effect-4:checked + label:before {
	content: "";
	display: inline-block;
	width: 16px;
	height: 16px;
	border: 2px solid $border-color;
	box-sizing: border-box;
	border-radius: 3px;
	margin-right: 20px;
	@include transition-mix($delay: 0.2s);
}

.checkbox-effect-4:not(:checked) + label:after,
.checkbox-effect-4:checked + label:after {
	content: "\f00c";
	font: {
		family: fontawesome;
		size: 22px;
	}
	display: flex;
	height: 100%;
	align-items:center;
	@include position-absolute($left: 2px, $top: 0);
	color: #20BFAA;
	@include transition-mix;
	transform-origin: center center;
	opacity: 0;
}
.checkbox-effect-4:not(:checked) + label:after {
	transform: scale(0);
}

.checkbox-effect-4:checked + label:before {
	transform: scale(0);
	opacity: 0;
	@include transition-mix;
}
.checkbox-effect-4:checked + label:after {
	transform: scale(1);
	opacity: 1;
	@include transition-mix($delay: 0.2s, $timing: cubic-bezier(0.57, 1.9, 0, 1.52));
}


.site-select {
	height: 300px;
}
</style>
